import { render, staticRenderFns } from "./overall.vue?vue&type=template&id=367418a6&scoped=true"
import script from "./overall.vue?vue&type=script&lang=js"
export * from "./overall.vue?vue&type=script&lang=js"
import style0 from "./overall.vue?vue&type=style&index=0&id=367418a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367418a6",
  null
  
)

export default component.exports